/**
 * This is exported on its own so it can be used client-side without pulling in couchdb-graphql stuff
 * (as most other files in /database do)
 */

/**
 * An array of keys that are not used by our current database
 */
export const omitKeys: string[] = [
  'PK',
  'SK',
  '_type',
  'GSI1PK',
  'GSI1SK',
  'GSI2PK',
  'GSI2SK',
  'GSI3PK',
  'GSI3SK',
  'GSI4PK',
  'GSI4SK',
  'GSI5PK',
  'GSI5SK',
  'error'
]
